<a href="javascript:void(0);" @click="downloadFile">
  <slot>下载</slot>
</a>